import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BBResponseContainer } from '../carrier/response-container';
import { Run } from '../models/run';
import { timeout, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MaMachineService {
  MACHINE_API = environment.BB_MA_DELIVERY_API + "run";

  constructor(private httpClient: HttpClient) { }

  fetchRun(runID: string, labId: string): Observable<BBResponseContainer> {
    let url = this.MACHINE_API + '/getRun/' + labId + "/" + runID;
    return this.httpClient.get<BBResponseContainer>(url);
  }

  fetchRuns(labId: string, workFlow?: string, fromDate?: Date): Observable<BBResponseContainer> {
    let url = this.MACHINE_API + '/getAllRuns/' + labId;
    const params = [];
    if (typeof workFlow !== 'undefined') {
      params.push(`workflow=${workFlow}`);
    }
    if (fromDate !== undefined && fromDate !== null) {
      params.push(`fromDate=${fromDate.toDateString()}`);
    }
    if (params){
      url = `${url}?${params.join("&")}`
    }
    return this.httpClient.get<BBResponseContainer>(url);
  }

  fetchRunSequence(labId: string): Observable<BBResponseContainer> {
    let url = this.MACHINE_API + '/getRunSequence/' + labId;
    return this.httpClient.get<BBResponseContainer>(url);
  }

  createRun(run: Run, labId: string): Observable<BBResponseContainer> {
    run.labId = labId;
    let url = this.MACHINE_API + '/createRun';
    return this.httpClient.post<BBResponseContainer>(url, run)
  }

  updateRun(run: Run, labId: string): Observable<BBResponseContainer> {
    let url = this.MACHINE_API + '/updateRun/' + labId + "/" + run.runId;
    return this.httpClient.put<BBResponseContainer>(url, run)
  }

  updateRunNewPlateID(requestBody: any) {
    let url = this.MACHINE_API + "/updateRun/duplicatePlate";
    return this.httpClient.put<BBResponseContainer>(url, requestBody).pipe(timeout(environment.defaultTimeout), tap({
      error: error => {
        error.url = url;
      }
    }));
  }
}
